// https://github.com/chakra-ui/chakra-ui/blob/master/packages/theme/src/components/popover.ts
export const Popover = {
  baseStyle: (props) => ({
    popper: { width: 'inherit' },
    content: { width: 'auto' },
  }),
}
